<template>
  <div>
    <v-tabs flat background-color="transparent" class="mb-0">
      <v-tabs-slider color="green"></v-tabs-slider>
      <v-tab :to="{ name: 'profile_info' }" exact>
        Profile Info
      </v-tab>
      <v-tab :to="{ name: 'billing' }">
        Billing
      </v-tab>
      <v-tab :to="{ name: 'profile_security' }">
        Security
      </v-tab>
      <v-tab :to="{ name: 'profile_privacy' }">
        Privacy
      </v-tab>
      <v-tab :to="{ name: 'profile_access' }">
        Account Access
      </v-tab>
      <v-tab :to="{ name: 'profile_ggseal' }">
        GreenGeeks Seal
      </v-tab>
    </v-tabs>
    <hr class="mt-0 mb-md-4">
  </div>
</template>

<script>
export default {
  name: 'ProfileNavigation'
}
</script>
